<template>
  <div class="consulting-modify">
    <!-- 筛选和搜索区域 -->
    <div class="search">
      <el-form label-width="80px">
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="状态:" @change="handleStatusChange">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="已通过" value="1"></el-option>
            <el-option label="已拒绝" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form label-width="80px">
        <el-form-item label="搜索">
          <div style="display: flex;align-items: center;flex-direction: row;justify-content: flex-start;">
            <el-select v-model="queryType" placeholder="搜索" style="margin-right: 10px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="申请人ID" value="1"></el-option>
              <el-option label="申请人昵称" value="2"></el-option>
            </el-select>
            <el-input style="width: 200px;" v-model="queryContent" placeholder="请输入搜索内容"></el-input>
            <img class="search-icon" src="/img/search-icon.png" @click="handleSearch" />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表区域 -->
    <div class="list-container">
      <div v-for="item in modifyList" :key="item.id" class="modify-item">
        <div class="item-header">
          <div class="item-info">
            <div class="info-row">
              <span class="label">申请人ID:</span>
              <span class="value">{{ item.applicateUserPhone }}</span>
            </div>
            <div class="info-row">
              <span class="label">申请人昵称:</span>
              <span class="value">{{ item.applicateUserNiceName }}</span>
            </div>
            <div class="info-row">
              <span class="label">详情页:</span>
              <span class="value">
                <el-button type="text" @click="openConsultDetail(item.consultantId)">查看</el-button>
              </span>
            </div>
            <div class="info-row">
              <span class="label">社保页:</span>
              <span class="value">
                <el-button type="text" @click="openSocialSecurity(item.consultantId)">查看</el-button>
              </span>
            </div>
          </div>
        </div>

        <!-- 变更信息 -->
        <div class="change-info">
          <!-- 名企经历变更 -->
          <div v-if="hasCompanyChange(item)" class="info-row">
            <span class="label">名企经历:</span>
            <span class="value">
              {{ formatCompanyList(item.updateBeforeWorkedFamousCompanyList) }} >
              {{ formatCompanyList(item.updateAfterWorkedFamousCompanyList) }}
            </span>
          </div>

          <!-- 工作年限变更 -->
          <div v-if="hasWorkYearsChange(item)" class="info-row">
            <span class="label">工作年限:</span>
            <span class="value">
              {{ item.updateBeforeWorkYears || '无' }}年 > {{ item.updateAfterWorkYears || '无' }}年
            </span>
          </div>

          <!-- 所在城市变更 -->
          <div v-if="hasAreaChange(item)" class="info-row">
            <span class="label">所在城市:</span>
            <span class="value">
              {{ item.updateBeforeAreaName || '无' }} > {{ item.updateAfterAreaName || '无' }}
            </span>
          </div>
        </div>

        <!-- 申请时间和状态信息 -->
        <div class="status-info">
          <div class="info-row">
            <span class="label">申请时间:</span>
            <span class="value">{{ item.createTime }}</span>
          </div>

          <!-- 拒绝原因 -->
          <div v-if="shouldShowRefuseReason(item)" class="info-row">
            <span class="label">拒绝原因:</span>
            <span class="value">
              <el-input
                v-if="item.status === 0"
                v-model="refuseReasons[item.id]"
                placeholder="请输入拒绝原因"
                style="width: 300px;"
              ></el-input>
              <span v-else>{{ item.refuseReason }}</span>
            </span>
          </div>

          <div class="info-row">
            <span class="label">状态:</span>
            <span class="value">
              <el-tag :type="getStatusType(item.status)">
                {{ getStatusText(item.status) }}
              </el-tag>
            </span>
          </div>

          <!-- 审核人 -->
          <div v-if="item.status !== 0" class="info-row">
            <span class="label">审核人:</span>
            <span class="value">{{ item.auditUserName || item.auditUserId }}</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div v-if="item.status === 0" class="action-buttons">
          <el-button type="success" @click="handlePass(item)">通过</el-button>
          <el-button type="warning" @click="handleReject(item)">拒绝</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getConsultingModifyList, consultingModifyPassed, consultingModifyRejected} from '../../api/background'

export default {
  name: 'ConsultingModify',
  props: {
    needList: {
      type: Array,
      default: () => []
    },
    pageNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      modifyList: [],
      status: '-1',
      queryType: '-1',
      queryContent: '',
      refuseReasons: {} // 存储每个申请的拒绝原因
    }
  },
  watch: {
    status() {
      this.getModifyList(this.pageNum)
    },
    queryType() {
      this.getModifyList(this.pageNum)
    },
    pageNum(val) {
      this.getModifyList(val)
    }
  },
  created() {
    this.getModifyList(1)
  },
  methods: {
    // 获取咨询修改列表
    getModifyList(page) {
      const params = {
        status: this.status === -1 ? -1 : this.status,
        queryType: this.queryType === -1 ? 1 : this.queryType,
        queryContent: this.queryContent,
        pageNum: page || 1
      }

      getConsultingModifyList(params)
        .then(res => {
          this.modifyList = res.data.records || []
          this.$emit('updatePendingTotal', res.data.pendingTotal || 0)
        })
        .catch(err => {
          console.error('获取咨询修改列表失败:', err)
          this.$message.error('获取数据失败')
        })
    },

    // 状态筛选变化
    handleStatusChange() {
      this.getModifyList(this.pageNum)
    },

    // 搜索
    handleSearch() {
      // if (this.queryType === '-1' && this.queryContent) {
      //   this.$message.error('请选择搜索类型')
      //   return
      // }
      this.getModifyList(this.pageNum)
    },

    // 检查是否有名企经历变更
    hasCompanyChange(item) {
      console.log(item,'tttt');
      const before = item.updateBeforeWorkedFamousCompanyList || []
      const after = item.updateAfterWorkedFamousCompanyList || []
      return before?.length > 0 || after.length > 0
    },

    // 检查是否有工作年限变更
    hasWorkYearsChange(item) {
      
      return item.updateBeforeWorkYears !== item.updateAfterWorkYears
    },

    // 检查是否有城市变更
    hasAreaChange(item) {
      return item.updateBeforeAreaId !== item.updateAfterAreaId
    },

    // 格式化名企经历列表
    formatCompanyList(companyList) {
      if (!companyList || companyList.length === 0) {
        return '无'
      }
      return companyList.map(company => company.name || company).join('、')
    },

    // 是否显示拒绝原因
    shouldShowRefuseReason(item) {
      if (item.status === 0) {
        return true // 待审核状态始终显示
      }
      return item.refuseReason && item.refuseReason.trim() !== '' // 已处理状态，有原因才显示
    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        0: 'warning', // 待审核
        1: 'success', // 已通过
        2: 'danger' // 已拒绝
      }
      return statusMap[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝'
      }
      return statusMap[status] || '未知'
    },

    // 打开咨询详情页
    openConsultDetail(consultantId) {
      const routeData = this.$router.resolve({
        path: '/personalConsultDetail',
        query: {consultant_id: consultantId}
      })
      window.open(routeData.href, '_blank')
    },

    // 打开社保记录页
    openSocialSecurity(consultantId) {
      const routeData = this.$router.resolve({
        path: '/socialSecurity',
        query: {consultant_id: consultantId}
      })
      window.open(routeData.href, '_blank')
    },

    // 通过申请
    handlePass(item) {
      this.$confirm('确认通过此申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          consultingModifyPassed({id: item.id})
            .then(() => {
              this.$message.success('操作成功')
              this.getModifyList(this.pageNum)
              this.$emit('refreshNeedList')
            })
            .catch(err => {
              console.error('通过申请失败:', err)
              this.$message.error('操作失败')
            })
        })
        .catch(() => {
          // 用户取消
        })
    },

    // 拒绝申请
    handleReject(item) {
      const refuseReason = this.refuseReasons[item.id]
      if (!refuseReason || refuseReason.trim() === '') {
        this.$message.error('请输入拒绝原因')
        return
      }

      this.$confirm('确认拒绝此申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          consultingModifyRejected({
            id: item.id,
            reason: refuseReason.trim()
          })
            .then(() => {
              this.$message.success('操作成功')
              this.getModifyList(this.pageNum)
              this.$emit('refreshNeedList')
            })
            .catch(err => {
              console.error('拒绝申请失败:', err)
              this.$message.error('操作失败')
            })
        })
        .catch(() => {
          // 用户取消
        })
    }
  }
}
</script>

<style scoped>
.consulting-modify {
  padding: 20px;
}

.search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.search-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-left: 20px;
}

.list-container {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.modify-item {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  padding: 20px;
}

.modify-item:last-child {
  border-bottom: 1px solid #e4e7ed;
}

.item-header {
  margin-bottom: 15px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.label {
  min-width: 100px;
  font-weight: 500;
  color: #606266;
}

.value {
  color: #303133;
  flex: 1;
}

.change-info {
  margin: 15px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
}

.status-info {
  margin: 15px 0;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
}

.action-buttons .el-button {
  margin-left: 10px;
}
</style>
